import Cookies from 'js-cookie';

import FallBack from '@/components/SuspenseFallBack';
import { KEY_MYGPT_REFRESH_TOKEN, KEY_MYGPT_TOKEN, KEY_MYGPT_TOKEN_EXPIRESIN } from '@/constant';
import { useLogin } from '@/hooks/useLogin';

export function RequireAuth({ children }: { children: JSX.Element }) {
  const { login, refreshToken: refreshTokenMethod } = useLogin();

  const token = Cookies.get(KEY_MYGPT_TOKEN);
  const tokenExpires = Cookies.get(KEY_MYGPT_TOKEN_EXPIRESIN);
  const refreshToken = Cookies.get(KEY_MYGPT_REFRESH_TOKEN);

  // 检查是否有token
  // 检查是否过期
  // 是否替换token成功
  // 否则跳去登录
  let needLogin = false;

  for (;;) {
    if (!token) {
      needLogin = true;
      break;
    }

    if (tokenExpires) {
      const nowTime = new Date().getTime();
      const expiresTime = Number(tokenExpires);
      if (expiresTime > nowTime) break;
    }

    if (refreshToken) {
      const data = refreshTokenMethod();
      if (!data) {
        needLogin = true;
        break;
      }
    }

    break;
  }

  if (needLogin) {
    login(window.location.href);
    return <FallBack />;
  } else {
    return children;
  }
}
